import List from './components/List'
const ContractUpdateModules = {
    List,
}
export default ContractUpdateModules
